"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitFormButton = exports.useFormButton = exports.FormButton = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const FormButton_1 = require("@reactionable/core/lib/form/FormButton");
const Button_1 = tslib_1.__importDefault(require("react-bootstrap/Button"));
function FormButton(props) {
    return jsx_runtime_1.jsx(Button_1.default, Object.assign({ variant: "primary" }, props), void 0);
}
exports.FormButton = FormButton;
function useFormButton(props) {
    return FormButton_1.useFormButton(Object.assign(Object.assign({}, props), { Component: FormButton }));
}
exports.useFormButton = useFormButton;
function useSubmitFormButton(props) {
    return FormButton_1.useSubmitFormButton(Object.assign(Object.assign({}, props), { Component: FormButton }));
}
exports.useSubmitFormButton = useSubmitFormButton;
//# sourceMappingURL=FormButton.js.map